<template>
    <div class="summary-header funding-provisions__header">
        <div class="summary-header__label">{{ params.displayName }}</div>
        <div class="summary-header__toggle-container">
            <span>{{ toSentenceCase($t('planning.promotionsMaintenance.funding.show')) }}:</span>
            <v-btn-toggle v-model="toggleMode" mandatory="force" @update:model-value="onToggle">
                <v-btn size="large" :value="fundingToggleStates.all">
                    {{ toSentenceCase($t('planning.promotionsMaintenance.funding.all')) }}
                </v-btn>
                <v-btn size="large" :value="fundingToggleStates.volumeFunding">
                    {{ toSentenceCase($t('planning.promotionsMaintenance.funding.volume')) }}
                </v-btn>
                <v-btn size="large" :value="fundingToggleStates.lumpFunding">
                    {{ toSentenceCase($t('planning.promotionsMaintenance.funding.lump')) }}
                </v-btn>
                <v-btn size="large" :value="fundingToggleStates.variableFunding">
                    {{ toSentenceCase($t('planning.promotionsMaintenance.funding.variable')) }}
                </v-btn>
            </v-btn-toggle>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { get, has } from 'lodash';
import fundingToggleStatesEnum from '@enums/funding-toggle-states';
import promoTabsEnum from '@enums/promotion-tabs';

export default defineComponent({
    data() {
        return {
            toggleMode: fundingToggleStatesEnum.volumeFunding,
            fundingToggleStates: fundingToggleStatesEnum,
            promoTabsEnum,
        };
    },
    computed: {
        ...mapState('promotions', ['unsavedPromotion']),
        showUnsaveMessage() {
            return get(
                this.unsavedPromotion[this.params.promotionId],
                promoTabsEnum.funding,
                false
            );
        },
    },
    mounted() {
        this.toggleMode = has(this.params, 'toggleMode')
            ? this.params.toggleMode()
            : fundingToggleStatesEnum.volumeFunding;
    },
    methods: {
        onToggle(value) {
            this.params.setToggleMode({ value });
        },
    },
});
</script>

<style lang="scss">
@import '@style/base/_variables.scss';

.summary-header.funding-provisions__header {
    flex-grow: 1;
    height: 100%;
    display: flex;

    flex-direction: column;
    justify-content: space-between;

    .summary-header__button {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }

    .summary-header__toggle-container {
        display: flex;
        margin-top: 2rem;
        span {
            padding-top: 0.2rem;
            margin-right: 1rem;
        }
    }

    .summary-header__banner {
        height: 3rem;
        margin: 1rem;
        padding: 0.5rem 1rem;
        background-color: $promo-rag-2;
        border: 0.1rem solid $promo-orange-dark;
        border-radius: 0.5rem;
        font-weight: normal;
    }
}
</style>
